<script lang="ts" setup>
import { getTime } from "~/utils/miscUtils";

const props = defineProps<{
  date: string;
}>();
</script>

<template>
  <el-popover effect="light" trigger="hover" placement="right" width="auto">
    <template #default>
      <div>
        {{ getTime(date) }}
      </div>
    </template>
    <template #reference>
      <el-tag effect="light" type="info"> {{ date.split("T")[0] }}</el-tag>
    </template>
  </el-popover>
</template>
